import { render, staticRenderFns } from "./AtencionesBase.vue?vue&type=template&id=831d6f34&"
import script from "./AtencionesBase.vue?vue&type=script&lang=ts&"
export * from "./AtencionesBase.vue?vue&type=script&lang=ts&"
import style0 from "./AtencionesBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports